<div class="tw-fluid tw-overflow-y-visible">
    <!-- Intro / message -->
    <p class="tw-text-sm tw-text-color-secondary">
        {{ transloco.translate('admin.labels.labelInUseDialog.message') }}
    </p>

    <!-- Scrollable Domains List -->
    <div class="tw-max-h-[360px] tw-overflow-y-auto tw-space-y-4" data-testid="label-in-use-domains">
        <ng-container *ngFor="let domain of domains">
            <div class="tw-border tw-rounded tw-bg-surface tw-p-4 tw-shadow-sm domain-card">
                <div class="tw-flex tw-items-start tw-justify-between tw-mb-2">
                    <div>
                        <h3 class="tw-text-base tw-font-medium tw-m-0">{{ domain.title }}</h3>
                        <a
                            [href]="domain.url"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="tw-inline-flex tw-items-center tw-gap-1 tw-text-primary tw-text-sm tw-mt-1 tw-no-underline"
                        >
                            <span class="tw-underline tw-me-1">{{ domain.url }}</span><i class="pi pi-external-link tw-text-xs"></i>
                        </a>
                    </div>
                </div>

                <!-- Domain Groups -->
                <ul class="tw-mt-3 tw-space-y-2 tw-list-none tw-p-0" data-testid="label-in-use-groups">
                    <li *ngFor="let group of domain.domain_groups" class="tw-flex tw-items-center tw-gap-2">
                        <div
                            class="tw-rounded-md tw-inline-block tw-px-2 tw-py-1"
                            [ngStyle]="{
                                color: label.color | adaptiveColor,
                                'background-color': label.color
                            }"
                        >
                            <span class="tw-text-sm tw-font-semibold tw-cursor-default">{{ label.name }}</span>
                        </div>
                        <span class="tw-text-sm">{{ group.title }}</span>
                    </li>
                </ul>
            </div>
        </ng-container>
    </div>

    <!-- Pagination -->
    <p-paginator
        [rows]="DEFAULT_PAGE_SIZE"
        [totalRecords]="domains.length || 0"
        [first]="first"
        (onPageChange)="onPageChange($event)"
        [rowsPerPageOptions]="AVAILABLE_PAGE_SIZE"
        styleClass="tw-border-t tw-pt-2"
        appendTo="body"
    ></p-paginator>

    <!-- Actions -->
    <div class="tw-flex tw-justify-end tw-gap-2 tw-pt-2">
        <p-button
            type="button"
            class="p-button-text"
            (click)="close(false)"
            (keydown.enter)="close(false)"
            (keydown.space)="close(false)"
            [label]="transloco.translate('admin.labels.labelInUseDialog.cancelBtnLabel')"
            severity="secondary"
        ></p-button>
        <p-button
            type="button"
            (click)="close(true)"
            (keydown.enter)="close(true)"
            (keydown.space)="close(true)"
            [label]="transloco.translate('admin.labels.labelInUseDialog.domainOverviewBtnLabel')"
            severity="primary"
        ></p-button>
    </div>
</div>